import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { PermissionAclService } from '../services/permission-acl.service';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})

export class GenericGuard implements CanActivate {

  res: boolean;

  constructor(
    private permissionAcl: PermissionAclService
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  Promise<boolean>  {

   const permissionName = route.data.role;

   if(typeof permissionName !== 'object'){
      return new Promise((resolve,reject)=>{
        this.permissionAcl.has(permissionName).subscribe({
          next: (r) => {
            if(r.result === false){
              Swal.fire({
                title: 'Erro',
                text: 'Usuário sem permissão',
                icon: 'error',
                customClass: 'sw-system',
              } as SweetAlertOptions);
            }
            resolve(r.result);
          },
          error: (e) => reject(e)
        })
     });
   }else{
    const grupo = permissionName.grupo;
    return new Promise((resolve,reject)=>{
      this.permissionAcl.hasGroup(grupo).subscribe({
        next: (r) => {
          resolve(r.result);
        },
        error: (e) => reject(e)
      })
   });
   }
  }

}
